module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      Select Service Provider Account\n    ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "list-group-item active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n        Service Provider Account\n        ")]), _vm._v(" "), _vm._l((_vm.$store.state.auth.managed_sps), function(customer) {
    return _c('a', {
      staticClass: "list-group-item",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectSP(customer)
        }
      }
    }, [_vm._v(_vm._s(customer.sp_id) + " - " + _vm._s(customer.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d920f66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/login/select/index.vue
// module id = 218
// module chunks = 1